/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useAppState } from '@nutastic/nutastic-react-app';
import ContentMusicPage from './ContentMusicPage';
import ContentVideoPage from './ContentVideoPage';
import ContentArtistPage from './ContentArtistPage';
import ListPage from './ListPage';
import ModalPageContainer from '../ModalPageContainer';
import { useNavigation } from '../../hooks/useNavigation';
import { useNuStreamerContext } from '../../refactor/nu-streamer/NuStreamerContext';
import ShopListPage from './ShopListPage';
import ShopProductPage from './ShopProductPage';
import LoadingOverlay from '../LoadingOverlay';
import { CONSTANTS } from '../../utils/constants';
import SeriesPage from './SeriesPage';
import { scrollToTopOfContentPage } from '../../utils/scrollToTopOfPage';

const VALID_TYPES = [CONSTANTS.APPKEY_MUSIC, CONSTANTS.APPKEY_VIDEOS, CONSTANTS.APPKEY_ARTIST];

const ContentPage = () => {
    const { isProcessing } = useAppState();
    const { contentType } = useParams();
    const { loadPage } = useNavigation();
    const { setIsPlayingVideo, showCompactVideo, setShowCompactVideo, isPlayingVideo, stopVideoPlayer } = useNuStreamerContext();
    const windowPath = window.location.pathname;
    const isShopPage = windowPath.includes('/shop') || windowPath.includes('/series');
    const shouldShowModal = VALID_TYPES.includes(contentType) || isShopPage;
    const isPlayingVideoRef = useRef(isPlayingVideo);
    const showCompactVideoRef = useRef(showCompactVideo);

    useEffect(() => {
        isPlayingVideoRef.current = isPlayingVideo;
        showCompactVideoRef.current = showCompactVideo;
    }, [isPlayingVideo, showCompactVideo]);

    useEffect(() => {
        const handlePopState = () => {
            scrollToTopOfContentPage();
            if ( isPlayingVideoRef.current && !showCompactVideoRef.current ) {
                setIsPlayingVideo(false);
                setShowCompactVideo(true);
            } else if ( !showCompactVideoRef.current ) {
                stopVideoPlayer();
            }
        };
        window.addEventListener('popstate', handlePopState);
        if ('navigation' in window) {
            window.navigation.addEventListener('navigate', handlePopState);
        }

        return () => {
            window.removeEventListener('popstate', handlePopState);
            if ('navigation' in window) {
                window.navigation.removeEventListener('navigate', handlePopState);
            }
        }
    }, []);

    const goBackButtonClicked = () => {
        const referrer = document.referrer;
        // Check if the referrer exists and belongs to your own website
        if (referrer && referrer.includes(window.location.hostname)) {
            window.history.back();
        } else if (window.history.length > 1) {
            window.history.back();
        } else {
            loadPage('/');
        }
    };

    const onCloseClick = () => {
        if ( isPlayingVideo && !showCompactVideo ) {
            setIsPlayingVideo(false);
            setShowCompactVideo(true);
        } else if ( !showCompactVideo ) {
            stopVideoPlayer();
        }
        loadPage('/');
    };

    return <ModalPageContainer isActive={shouldShowModal} onClose={onCloseClick} className="nuContent">
        { isProcessing && <LoadingOverlay /> }
        <Switch>
            <Route path={"/list/:type/:id?"} component={ListPage} />
            <Route path={"/content/music/:id"} component={ContentMusicPage} />
            <Route path={"/content/video/:id"} component={ContentVideoPage} />
            <Route path={"/content/artist/:id"} component={ContentArtistPage} />
            <Route path={"/series/:id"} component={SeriesPage} />
            <Route path={"/shop"} exact={true} component={ShopListPage} />
            <Route path={"/shop/:id"} component={ShopProductPage} />
        </Switch>
        <div className="contentPageBackButton">
            <button onClick={goBackButtonClicked} className="btn btn-dark-red"><i className="fa fa-arrow-circle-o-left mr-4" />Go Back</button>
        </div>
    </ModalPageContainer>
};

export default ContentPage;
